import axios from 'axios';
import { TokenLogout } from 'API/Logout/logout';

const api = process.env.REACT_APP_BASE_URL;

export const AddUser = async (Input, setIsLoading, setSuccess, setError, setInput, refunction, setEmployeeOnboarding) => {
  setIsLoading(true);
  try {
    await axios
      .post(
        `${api}/auth/add_user`,
        { ...Input },
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem('token')}`
          }
        }
      )
      .then((res) => {
        if (res.status === 201) {
          setIsLoading(false);
          setSuccess(res.data.message);
          setInput({
            date_of_joining: '',
            department_id: '',
            designation_id: '',
            email_id: '',
            employee_code: '',
            username: '',
            mobile_no: ''
          });
          setTimeout(() => {
            setSuccess(false);
            refunction();
            setEmployeeOnboarding(false);
          }, 2000);
        }
      })
      .catch((error) => {
        TokenLogout(error);
        setIsLoading(false);
        setError(error.response ? error.response.data.error : 'Unable to submit the employee');
      });
  } catch (error) {
    TokenLogout(error);
    setIsLoading(false);
    setError(error.response ? error.response.data.error : 'Unable to submit the employee');
  }
};

export const AddDepartmentapi = async (Input, setIsLoading, setSuccess, setError, setShowNewDesignation, setFormData) => {
  setIsLoading(true);
  try {
    await axios
      .post(
        `${api}/hr/departments`,
        { ...Input },
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem('token')}`
          }
        }
      )
      .then((res) => {
        if (res.status === 201) {
          setIsLoading(false);
          setSuccess(res.data.message);
          setShowNewDesignation(false);
          setFormData({ name: '', designations: [], newDesignation: '' });
        }
      })
      .catch((error) => {
        console.log('erer', error);
        TokenLogout(error);
        setIsLoading(false);
        setError(error.response ? error.response.data.error : 'Something went wrong');
      });
  } catch (error) {
    console.log('erer', error);
    TokenLogout(error);
    setIsLoading(false);
    setError(error.response ? error.response.data.error : 'Something went wrong');
  }
};

export const ViewDesignation = async (setIsLoading, setDesignationData, setError) => {
  setIsLoading(true);
  try {
    await axios
      .get(`${api}/hr/designations`, {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem('token')}`
        }
      })
      .then((res) => {
        if (res.status === 200) {
          setIsLoading(false);
          setDesignationData(res.data);
        }
      })
      .catch((error) => {
        console.log('erer', error);
        TokenLogout(error);
        setIsLoading(false);
        setError(error.response ? error.response.data.error : 'Something went wrong');
      });
  } catch (error) {
    console.log('erer', error);
    TokenLogout(error);
    setIsLoading(false);
    setError(error.response ? error.response.data.error : 'Something went wrong');
  }
};

export const AddDesignation = async (
  newDesignation,
  setIsLoading,
  setSuccess,
  setError,
  setShowNewDesignation,
  setFormData,
  refunction
) => {
  setIsLoading(true);
  try {
    await axios
      .post(
        `${api}/hr/designations`,
        { name: newDesignation },
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem('token')}`
          }
        }
      )

      .then((res) => {
        if (res.status === 201) {
          setIsLoading(false);
          setSuccess(res.data.message);
          setShowNewDesignation(false);
          setFormData({ name: '', designations: [], newDesignation: '' });
          setTimeout(() => {
            refunction();
          }, 2000);
        }
      })
      .catch((error) => {
        console.log('erer', error);
        TokenLogout(error);
        setIsLoading(false);
        setError(error.response ? error.response.data.error : 'Something went wrong');
      });
  } catch (error) {
    console.log('erer', error);
    TokenLogout(error);
    setIsLoading(false);
    setError(error.response ? error.response.data.error : 'Something went wrong');
  }
};

export const ViewDepartment = async (setIsLoading, setDepartmentData, setError) => {
  setIsLoading(true);
  try {
    await axios
      .get(`${api}/hr/departments`, {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem('token')}`
        }
      })
      .then((res) => {
        if (res.status === 200) {
          setIsLoading(false);
          setDepartmentData(res.data);
        }
      })
      .catch((error) => {
        console.log('erer', error);
        TokenLogout(error);
        setIsLoading(false);
        setError(error.response ? error.response.data.error : 'Something went wrong');
      });
  } catch (error) {
    console.log('erer', error);
    TokenLogout(error);
    setIsLoading(false);
    setError(error.response ? error.response.data.error : 'Something went wrong');
  }
};

export const EmployeeUser = async (page, rowsPerPage, Filter, setEmployeeData, setIsLoading, setError, setTotalCount) => {
  setIsLoading(true);
  const params = new URLSearchParams();

  if (Filter.employee_code) {
    params.append('employee_code', Filter.employee_code);
  }

  if (Filter.name) {
    params.append('username', Filter.name);
  }
  params.append('page', page);
  params.append('limit', rowsPerPage);

  try {
    await axios
      .get(`${api}/auth/list_users`, {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem('token')}`
        },
        params
      })
      .then((res) => {
        if (res.status === 200) {
          setIsLoading(false);
          setEmployeeData(res.data.data);
          setTotalCount(res.data.total_count);
        }
      })
      .catch((error) => {
        TokenLogout(error);
        setIsLoading(false);
        setError(error.response ? error.response.data.error : 'Something went wrong');
      });
  } catch (error) {
    TokenLogout(error);
    setIsLoading(false);
    setError(error.response ? error.response.data.error : 'Something went wrong');
  }
};

export const UpdateDepartment = async (EditData, setIsLoading, setSuccess, setError, setOpen, refunction) => {
  setIsLoading(true);

  try {
    await axios
      .post(
        `${api}/hr/update_department_designations`,
        {
          ...EditData
        },
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem('token')}`
          }
        }
      )
      .then((res) => {
        setSuccess(res.data.message);
        setTimeout(() => {
          setOpen(false);
          setIsLoading(false);
          refunction();
        }, 1500);
      })
      .catch((error) => {
        TokenLogout(error);
        setIsLoading(false);
        setError(error.response ? error.response.data.error : 'Something went wrong');
      });
  } catch (error) {
    TokenLogout(error);
    setIsLoading(false);
    setError(error.response ? error.response.data.error : 'Something went wrong');
  }
};

export const FetchAllUserRoles = async (setIsLoading, setUserRoles, handleAlertOpen) => {
  setIsLoading(true);
  try {
    await axios
      .get(`${api}/auth/list_user_types`, {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem('token')}`
        }
      })
      .then((res) => {
        if (res.status === 200) {
          setIsLoading(false);
          setUserRoles(res.data);
        }
      })
      .catch((error) => {
        TokenLogout(error);
        setIsLoading(false);
        handleAlertOpen(error.response && error.response.data.error ? error.response.data.error : 'Something went wrong', 'error');
      });
  } catch (error) {
    TokenLogout(error);
    setIsLoading(false);
    handleAlertOpen(error.response && error.response.data.error ? error.response.data.error : 'Something went wrong', 'error');
  }
};

export const FetchUserRoles = async (userId, setIsLoading, setUserRoles, handleAlertOpen, handleClose, handleGet) => {
  try {
    setIsLoading(true);
    await axios.get(`${api}/auth/list_user_roles`, {
    headers: {

              Authorization:`Bearer ${sessionStorage.getItem('token')}`

    },
    params:{
      user_id: userId
    }
    })
    .then((res) => {
      if (res.status === 200) {
        setIsLoading(false);
        setUserRoles(res.data);
      }
    })
  }
  catch(error){
    TokenLogout(error);
    setIsLoading(false);
    handleAlertOpen(error.response && error.response.data.error ? error.response.data.error : 'Something went wrong', 'error');
    if (error.response && error.response.data.error === 'No roles found for this user') {
      handleGet();
      setUserRoles([]);
      handleClose();
      return;
    }
  }
};

export const UpdateUserRole = async (userId, roleId, setIsLoading, handleAlertOpen, handleClose, handleGet) => {
  try {
    setIsLoading(true);
    await axios
      .post(
        `${api}/auth/add_roles`,
        {
          user_id: userId,
          user_types: roleId //need to update as api is changed
        },
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem('token')}`
          }
        }
      )
      .then((res) => {
        if (res.status === 201) {
          setIsLoading(false);
          handleAlertOpen(res.data.message, 'success');
          handleClose();
          handleGet();
        }
      })
      .catch((error) => {
        TokenLogout(error);
        setIsLoading(false);
        handleAlertOpen(error.response && error.response.data.error ? error.response.data.error : 'Something went wrong', 'error');
      });
  } catch (error) {
    TokenLogout(error);
    setIsLoading(false);
    handleAlertOpen(error.response && error.response.data.error ? error.response.data.error : 'Something went wrong', 'error');
  }
};

export const UserRoleUpdate = async (userId, roleId, type, setIsLoading, handleAlertOpen, handleGet) => {
  let payload = {
    user_id: userId
  };
  type === 'add' ? (payload.add_user_types = roleId) : (payload.remove_user_types = roleId);

  try {
    setIsLoading(true);
    await axios
      .post(
        `${api}/auth/update_roles`,
        {
          ...payload
        },
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem('token')}`
          }
        }
      )
      .then((res) => {
        handleGet();
        setIsLoading(false);
        handleAlertOpen(res.data.message, 'success');
      })
      .catch((error) => {
        TokenLogout(error);
        setIsLoading(false);
        handleAlertOpen(error.response && error.response.data.error ? error.response.data.error : 'Something went wrong', 'error');
      });
  } catch (error) {
    TokenLogout(error);
    setIsLoading(false);
    handleAlertOpen(error.response && error.response.data.error ? error.response.data.error : 'Something went wrong', 'error');
  } finally {
    setIsLoading(false);
  }
};

export const UploadUserRoles = async (role, setIsLoading, handleAlertOpen, setUserRole) => {
  setIsLoading(true);
  try {
    await axios
      .post(
        `${api}/auth/add_user_type`,
        { ...role },
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem('token')}`
          }
        }
      )
      .then((res) => {
        setIsLoading(false);
        handleAlertOpen(res.data.message, 'success');
        setUserRole({});
      })
      .catch((error) => {
        TokenLogout(error);
        setIsLoading(false);
        handleAlertOpen(error.response ? error.response.data.error : 'Something went wrong', 'error');
      });
  } catch (error) {
    TokenLogout(error);
    setIsLoading(false);
    handleAlertOpen(error.response ? error.response.data.error : 'Something went wrong', 'error');
  } finally {
    setIsLoading(false);
  }
};
